export const INDEPTH_PAGE_GET_ALL_SUCCESS = 'INDEPTH_PAGE_GET_ALL_SUCCESS';
export const INDEPTH_GET_ALL_FAILURE = 'INDEPTH_GET_ALL_FAILURE';
export const INDEPTH_DATA_IS_LOADING = 'INDEPTH_DATA_IS_LOADING';
